"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIGHT_TYPE = void 0;
var LIGHT_TYPE;
(function (LIGHT_TYPE) {
    LIGHT_TYPE["AMBIENT"] = "ambient";
    LIGHT_TYPE["DIRECTIONAL"] = "directional";
    LIGHT_TYPE["HEMISPHERE"] = "hemisphere";
    LIGHT_TYPE["POINT"] = "point";
    LIGHT_TYPE["RECTANGLE"] = "rectangle";
    LIGHT_TYPE["SPOT"] = "spot";
})(LIGHT_TYPE = exports.LIGHT_TYPE || (exports.LIGHT_TYPE = {}));
//# sourceMappingURL=ILight.js.map